import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { BrowserRouter } from "react-router";
import { AuthContextProvider } from "./store";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter basename="">
      <AuthContextProvider>
        <App />
      </AuthContextProvider>
      <ToastContainer />
    </BrowserRouter>
  </React.StrictMode>
);
